import React, { memo } from "react";
import Box from "../../Components/Box";
import AppLayout from "../../Components/layout/AppLayout";
import Navbar from "../../Components/navbar/Navbar";
import useWindowSize from "../../hooks/useWindowSize";
import StyledPage from "./PageStyle";


const Page = memo(function Page(props) {

  //console.log(props.page.data.content);

  const screenWidth = useWindowSize()

  return (
   
      <AppLayout navbar={<Navbar />} seo={props.seo}>
        <StyledPage
          width={screenWidth > 900 ? '80%' : '90%'}
          m='auto'
          paddingTop='12rem'
        >
          <Box

            fontSize={screenWidth > 1980 ? '0.8vw' : 'inherit'}
            dangerouslySetInnerHTML={{ __html: props?.page?.data?.content }}>
          </Box>
        </StyledPage>
      </AppLayout >
    
  );
});



export default Page;
